import * as React  from 'react';
import { useEffect, useState } from 'react';
import {getCsrfToken} from './../../../commons/authenticityToken'

const Confirm = (props) => {
  const [mTicketIds, setMTicketIds] = useState([]);

  useEffect(() => {
    async function getMTicketIds() {
      const IDs = props.m_tickets.map(t => (
        t.id
      ));
      setMTicketIds(IDs)
    }
    getMTicketIds();
  }, []);

  return(
    <>
      <form className="new_m_ticket justify-content-center"
        action="/tickets/data/purchase_complete"
        acceptCharset="UTF-8"
        method="post">
        <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
        <h3>購入内容</h3>
        <br/>
        <p>以下の内容で購入を確定します。</p>
        <br/>
        <div className="table-responsive">
          <table id="notice_table" className="table table-bordered">
            <thead>
              <tr className="success">
                <th scope="col" className="text-center col-lg-6">チケット名</th>
                <th scope="col" className="text-center col-lg-2">購入数</th>
                <th scope="col" className="text-center col-lg-2">価格</th>
                <th scope="col" className="text-center col-lg-2">金額</th>
              </tr>
            </thead>
            <tbody>
              {props.m_tickets.map((ticket, i) =>
                <tr key={i}>
                  <td>{ticket.name}</td>
                  <td className="text-right">{Number(ticket.purchase_count).toLocaleString()}</td>
                  <td className="text-right">{Number(ticket.price).toLocaleString()}</td>
                  <td className="text-right">{(ticket.purchase_count * ticket.price).toLocaleString()}</td>
                </tr>
              )}
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">小計</td>
                <td className="text-right ">{props.total_price.toLocaleString()}</td>
              </tr>
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">消費税(10%)</td>
                <td className="text-right ">{(props.total_price * 0.1).toLocaleString()}</td>
              </tr>
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">合計</td>
                <td className="text-right ">{(props.total_price * 1.1).toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
          {props.m_tickets.map((ticket, i) =>
            <span key={i}>
              <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "id"} value={ticket.id}></input>
              <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "pc"} value={ticket.purchase_count}></input>
            </span>
          )}
          </div>
          <div className="text-center" style={{fontSize: '18px', marginTop: '-6px'}}>※上記の内容で、後日請求書を送付させて頂きます。</div>
          <a className="btn btn-primary pull-left ml5 form-btn"
              href={`/tickets/data/purchase${props.company_id ? ('?company_id=' + props.company_id) : '' }`}>戻る</a>
          <input type="submit"
                value="購入する"
                className="btn btn-primary pull-right form-btn"
                data-disable-with="購入する" />

        <input name="total_fee" type="hidden" value={props.total_price * 1.1}></input>
        <input name="company_id" type="hidden" value={props.company_id}></input>
      </form>
    </>
  )
}

export default Confirm
